import type React from 'react';

/**
 * div role="button" 을 키보드로도 누를 수 있게 — Enter · Space 에서 실행(감사 card-controltower#441 — 사이드바 · 탭 · 필터 칩이
 * 키보드로 조작되지 않았다). tabIndex={0} 과 함께 쓴다. 반복 키는 무시한다.
 */
export const onActivateKey = (fn: () => void) => (e: React.KeyboardEvent) => {
  if (e.repeat) return;
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    fn();
  }
};
